export const DEFAULT_API_URL_V2 = import.meta.env.VITE_APP_GOMON_API_URL;
export const DEFAULT_API_URL_V3 = import.meta.env.VITE_APP_GENESIS_API_URL;

export const MANUFACTURING_SITE_NAME = "Manufacturing";
export const GET_BOARD_DATA_URL = "/lab-data/getBoardMapping/:board";
export const CHANGE_SAMPLING_TIME = "/lab-data/changeSampleTime";
export const CHANGE_BOARD_STATE = "/lab-data/setBoardState";
export const CHANGE_BOARD_IR = "/lab-data/setBoardMapping";
export const CHANGE_BOARD_SITE = "/lab-data/setBoardSite";
export const CHANGE_SITE_QUANTIFIER_DATA = "/lab-data/siteQuantifierData/";
export const KPI_GET_API = "/sensor-boards/search/:id";
export const RG_TEST_GET_API = "/sensor-boards/search-test/:id/:key";
export const CALIBRATION_INSERT_O2 = "/sensor-boards/calibration/oxygen/add";
export const GET_NEW_BOARDS_BATCH_CALIBRATION =
  "/calibration/getBatch/:type/:batch";
export const GET_BOARD_DETAILS_CALIBRATION =
  "/calibration/check-teraterm-values/:bb_label/:batch";
export const POST_BATCH_RAOULT_CALIBRATION =
  "/teraterm/ScheduleRaoultCalibration";
export const GET_O2_CALIBRATION = "/calibration/gas";
export const GET_CALIBRATION_BATCH = "/calibration/batchGas";
export const GET_LATEST_CALIBRATION =
  "/lab-data/get-latest-calibration-data/:bb_label";
export const GET_BATCH_SENSOR_TYPE = "/calibration/getBatchSensorType/:batch";

export const ADD_NDIR_CALIBRATION = "/calibration/add/ndir";
export const ADD_KPI = "/sensor-boards/kpi/add";
export const UPDATE_SITE_GATEWAY = "/lab-data/update-gateway";
export const UPDATE_SITE_GATEWAY_NOTES = "/lab-data/update-gateway-notes";
export const SEARCH_GATEWAYS = "/lab-data/search-gateway";
export const SEND_ALL_CALIBRATIONS = "/calibration/add/allCalibrations";
export const SEND_ALL_BOARD_CALIBRATIONS =
  "/calibration/add/allBoardCalibrations";
export const UPDATE_NORM_RESPONSES = "/calibration/add/normResponse";

export const GET_SENSOR_HISTORY = "/sensor-boards/history";
export const UPDATE_SENSOR_HISTORY = "/sensor-boards/update-history";

export const BELL = {
  DEFAULT: "https://restapi7.jasper.com/rws/api/v1/devices",
  USAGE: "/:ICCID/ctdUsages",
  SESSION_INFO: "/:ICCID/sessionInfo",
  EDIT_DETAILS: "/:ICCID",
};

export const PAGES = {
  QUANTIFIER: "/quantifier",
  TESTING_BOARDS: "/board_testing",
  CALIBRATION: "/calibration",
  HISTORY: "/history",
  AG_BOARDS: "/ag_testing",
  GATEWAYS: "/gateways",
  PLANS_OPTIMIZATION: "/plans-optimization",
  SITES: "/sites",
  USERS: "/user",
  FAILED_SENSORS: "/failed-sensors",
  DEPLOYMENTS: "/deployments",
  MANAGE: "/notes/manage",
  NOTES_SITE_FIELD: "/notes/site-field",
  NOTES_DISTRIBUTORS: "/notes/distributors",
};

export const PAGES_TITLES = {
  "/quantifier": "Quantifier",
  "/board_testing": "Board Testing",
  "/calibration": "Calibration",
  "/history": "Board History",
  "/gateways": "Gateways",
  "/plans-optimization": "Plans Optimization",
  "/notes/manage": "Crew",
  "/notes/site-field": "Notes",
  "/notes/distributors": "Distributors",
};

export const LINKS = {
  CONTACT_US: "https://ems-inc.ca/contact-us",
  GRAFANA: "https://liora-grafana.tail781803.ts.net",
  WISDM_GATEWAYS:
    "https://ems-inc.wisdm.rakwireless.com/location/in_field_%28na%29/connected-gateways",
};
export const GAS_BOUNDS = {
  ch4: [-1, 51],
  co2: [-1, 11],
  n2o: [-0.0001, 0.011],
  c3h8: [-0.5, 2.5],
};

export const STATE = {
  CALIBRATION: {
    value: "CALIBRATION",
    name: "Calibration",
  },
  PRE_PRODUCTION_RG: {
    value: "PRE_PRODUCTION_RG",
    name: "Pre Production RG",
  },
  POST_PRODUCTION_RG: {
    value: "POST_PRODUCTION_RG",
    name: "Post Production RG",
  },
  FIELD_RG: {
    value: "FIELD_RG",
    name: "Field RG",
  },
  IN_FIELD: {
    value: "IN_FIELD",
    name: "In Field",
  },
  GARBAGE: {
    value: "GARBAGE",
    name: "Garbage",
  },
};
export const KPI_GET_API_TEST = "/sensor-boards/kpi/get/:test";

export const SITES_ALL_API_URL = "/sites/all/not-internal";

export const CALIBRATION = "CALIBRATION";
export const RED_GREEN = "RG";

export const CATEGORY_FIELDS = [
  "Device Name",
  "DevEUI",
  "Device Type",
  "Device Type Name",
  "Gateway",
  "Quantifier Name",
  "Site Name",
  "State",
  "Status",
  "board_temperature",
  "concentration_ch4",
  "concentration_co2",
  "concentration_o2",
  "concentration_phc",
  "detector_temperature",
  "humidity",
  "pressure",
  "test_passed",
];

